import { fetch } from '@/utils/http'

export default {
  //订阅区块链
  getSubscribeQueryList: params =>
    fetch('get', '/cbaas-service/v1/chainManagement/subScribeChainQueryList', params),
  revokeSubscribe: params =>
    fetch('post', '/cbaas-service/v1/frontpage/subScribeChainRevoke', params),
  addSubscribe: params => fetch('post', '/cbaas-service/v1/frontpage/subScribeChain', params),
  updateSubscribe: params =>
    fetch('post', '/cbaas-service/v1/frontpage/subScribeChainUpdate', params),
  //首页展示
  getOverview: params => fetch('get', '/cbaas-service/v1/frontpage/queryOverview', params),
  getTxnLine: params => fetch('get', '/cbaas-service/v1/frontpage/queryTxNumLatest24Hour', params),
  //区块列表
  getBlockList: params => fetch('get', '/cbaas-service/v1/frontpage/queryBlockList', params),
  //合约列表
  getContractList: params => fetch('get', '/cbaas-service/v1/frontpage/queryContractList', params),
  //交易
  getTxnList: params => fetch('post', '/cbaas-service/v1/frontpage/queryTransactionList', params),
  //搜索
  getSearch: params => fetch('get', '/cbaas-service/v1/frontpage/queryMultiType', params),

  //根据请求参数返回监控数据
  getMultiple: params => fetch('post', '/cbaas-service/v1/monitor/queryDataMultiple', params),

  //根据请求参数返回监控数据
  getSingle: params => fetch('post', '/cbaas-service/v1/monitor/queryDataSingle', params)
}
